/* Belvoir&Co — slide to add to bag
   Progressive enhancement. The real <button type="submit" class="product-form__submit"> stays in the form
   (the prescription flow and the theme's ProductForm rely on it); this control just drives it.
   Drag the handle past 80% → submit. Tap the track → handle glides to the end → submit. Enter/Space on the
   handle → submit. Success is detected from the theme's loading spinner toggling, with a timeout fallback. */
(function () {
  'use strict';
  if (!('customElements' in window) || customElements.get('bv-slide-atc')) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class BvSlideAtc extends HTMLElement {
    connectedCallback() {
      /* The script is async in <head>, so the element can be upgraded the instant its start tag is parsed,
         before its children exist. In that case wait: the inline script after </bv-slide-atc> calls bvInit(),
         and DOMContentLoaded is the safety net. */
      if (!this.querySelector('.bv-slide__handle')) {
        if (!this._bvWait) {
          this._bvWait = true;
          var self = this;
          document.addEventListener('DOMContentLoaded', function () { self.bvInit(); }, { once: true });
        }
        return;
      }
      this.bvInit();
    }
    bvInit() {
      if (this._bvReady || !this.isConnected || !this.querySelector('.bv-slide__handle')) return;
      this._bvReady = true;
      this.track = this.querySelector('.bv-slide__track');
      this.handle = this.querySelector('.bv-slide__handle');
      this.fill = this.querySelector('.bv-slide__fill');
      this.label = this.querySelector('.bv-slide__label');
      /* Two modes: PDP (drives the real submit button) and card (adds the variant itself). */
      this.cardMode = this.classList.contains('bv-slide--card');
      if (!this.cardMode) {
        this.form = this.closest('form') || document.getElementById(this.getAttribute('data-form'));
        this.button = this.form && this.form.querySelector('.product-form__submit:not(.button--prescription)');
        if (!this.track || !this.handle || !this.button) { this.hidden = true; return; }
        if (this.button.disabled) { this.setAttribute('aria-disabled', 'true'); }
        var wrap = this.button.closest('.product-form__buttons'); if (wrap) wrap.classList.add('bv-has-slide');
      } else if (!this.track || !this.handle) { this.hidden = true; return; }

      this.pos = 0; this.max = 0; this.dragging = false; this.busy = false;
      this.measure();
      window.addEventListener('resize', this.measure.bind(this), { passive: true });

      this.handle.addEventListener('pointerdown', this.onDown.bind(this));
      this.handle.addEventListener('pointermove', this.onMove.bind(this));
      this.handle.addEventListener('pointerup', this.onUp.bind(this));
      this.handle.addEventListener('pointercancel', this.onUp.bind(this));
      this.handle.addEventListener('keydown', this.onKey.bind(this));
      this.track.addEventListener('click', this.onTrackClick.bind(this));

      if (this.cardMode) return;
      /* Mirror disabled state (sold-out variants) from the real button */
      this.mo = new MutationObserver(this.syncButton.bind(this));
      this.mo.observe(this.button, { attributes: true, attributeFilter: ['disabled'] });

      /* Success detection: spinner shown → hidden again */
      this.spinner = this.button.querySelector('.loading__spinner');
      if (this.spinner) {
        this.spinnerMo = new MutationObserver(this.onSpinner.bind(this));
        this.spinnerMo.observe(this.spinner, { attributes: true, attributeFilter: ['class'] });
      }
    }
    disconnectedCallback() { if (this.mo) this.mo.disconnect(); if (this.spinnerMo) this.spinnerMo.disconnect(); }

    measure() { this.max = Math.max(0, this.track.clientWidth - this.handle.offsetWidth); }
    syncButton() {
      var off = this.button.disabled;
      this.toggleAttribute('aria-disabled', off);
      this.handle.tabIndex = off ? -1 : 0;
    }
    setPos(x, animate) {
      this.pos = Math.min(this.max, Math.max(0, x));
      var p = this.max ? this.pos / this.max : 0;
      this.handle.style.transition = animate ? '' : 'none';
      this.fill.style.transition = animate ? '' : 'none';
      this.handle.style.transform = 'translate3d(' + this.pos + 'px,0,0)';
      this.fill.style.transform = 'scaleX(' + p + ')';
      this.label.style.opacity = String(Math.max(0, 1 - p * 1.6));
      this.handle.setAttribute('aria-valuenow', String(Math.round(p * 100)));
    }

    onDown(e) {
      if (this.busy || this.hasAttribute('aria-disabled')) return;
      this.dragging = true; this.startX = e.clientX - this.pos;
      this.handle.setPointerCapture(e.pointerId);
      this.classList.add('is-dragging');
    }
    onMove(e) {
      if (!this.dragging) return;
      e.preventDefault();
      this.setPos(e.clientX - this.startX, false);
    }
    onUp(e) {
      if (!this.dragging) return;
      this.dragging = false; this.classList.remove('is-dragging');
      try { this.handle.releasePointerCapture(e.pointerId); } catch (err) {}
      if (this.max && this.pos / this.max >= 0.8) this.complete();
      else this.setPos(0, true);
    }
    onKey(e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.glide(); }
      if (e.key === 'ArrowRight') { e.preventDefault(); this.setPos(this.pos + this.max * 0.25, true); if (this.pos >= this.max * 0.8) this.complete(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); this.setPos(0, true); }
    }
    onTrackClick(e) {
      if (this.busy || this.dragging || this.hasAttribute('aria-disabled')) return;
      if (e.target.closest('.bv-slide__handle')) return; /* a tap on the handle without a drag */
      this.glide();
    }
    /* Tap fallback: the handle travels the track on its own, then submits */
    glide() {
      if (this.busy || this.hasAttribute('aria-disabled')) return;
      var self = this;
      if (reduce) { this.setPos(this.max, false); this.complete(); return; }
      this.setPos(this.max, true);
      setTimeout(function () { self.complete(); }, 380);
    }
    complete() {
      if (this.busy) return;
      this.busy = true;
      this.classList.add('is-busy');
      this.setPos(this.max, true);
      if (navigator.vibrate) { try { navigator.vibrate(12); } catch (err) {} }
      var self = this;
      this.dispatchEvent(new CustomEvent('bv:slide-atc', { bubbles: true }));
      if (this.cardMode) { this.addFromCard(); return; }
      this.sawSpinner = false;
      this.fallback = setTimeout(function () { self.done(); }, 6000);
      /* The theme's <product-form> (product-variants.js, deferred) turns the submit into an AJAX add + drawer.
         If someone slides before it is ready, a plain click would do a native form POST and navigate to /cart.
         So wait for the element to be defined, then click. */
      var fire = function () { self.button.click(); };
      var pf = this.button.closest('product-form');
      if (!pf || customElements.get('product-form')) fire();
      else customElements.whenDefined('product-form').then(function () { requestAnimationFrame(fire); });
    }
    /* Card mode: single variant → /cart/add with the drawer's sections so the theme re-renders and opens it;
       several variants → hand off to the theme's quick view trigger (the customer must pick). */
    addFromCard() {
      var self = this;
      var variants = parseInt(this.getAttribute('data-variants') || '1', 10);
      var trigger = this.querySelector('.quick-cart-drawer__trigger');
      if (variants > 1 && trigger) { trigger.click(); setTimeout(function () { self.done(true); }, 300); return; }
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var body = { items: [{ id: parseInt(this.getAttribute('data-variant-id'), 10), quantity: 1 }] };
      if (cart && cart.getSectionsToRender) {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.section; });
        body.sections_url = window.location.pathname;
      }
      var routes = window.routes || {};
      fetch(((routes.cart_add_url || '/cart/add') + '.js').replace('.js.js', '.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (res.status || res.errors) { self.fail(); return; }
        if (cart && cart.renderContents) cart.renderContents(res);
        if (typeof updateCartCounters === 'function') updateCartCounters();
        self.done();
      }).catch(function () { self.fail(); });
    }
    fail() {
      this.classList.remove('is-busy'); this.busy = false; this.setPos(0, true);
      var trigger = this.querySelector('.quick-cart-drawer__trigger');
      if (trigger) trigger.click(); else if (this.getAttribute('data-product-url')) location.href = this.getAttribute('data-product-url');
    }
    onSpinner() {
      var hidden = this.spinner.classList.contains('hidden');
      if (!hidden) { this.sawSpinner = true; return; }
      if (this.sawSpinner) this.done();
    }
    done(quiet) {
      clearTimeout(this.fallback);
      this.classList.remove('is-busy');
      if (quiet) { this.busy = false; this.setPos(0, true); return; }
      this.classList.add('is-done');
      var self = this;
      setTimeout(function () {
        self.classList.remove('is-done');
        self.setPos(0, true);
        self.busy = false;
      }, 2200);
    }
  }
  customElements.define('bv-slide-atc', BvSlideAtc);
})();